<template>
  <section class="london-office">
    <div class="london-office--black">
      <div class="container">
        <h2 class="london-office__title">{{ blok.title }}</h2>
        <h3 class="london-office__country">{{ blok.country_name }}</h3>

        <ul class="london-office__list row">
          <li class="london-office__list-item col-12 col-lg-5">
            <p class="london-office__list-intro">{{ blok.intro }}</p>
            <a
              :href="blok.map_url"
              target="_blank"
              class="london-office__link london-office__link--map icon icon--arrow"
              ><span>{{ blok.map_display }}</span></a
            >
          </li>
          <li class="london-office__list-item col-12 col-lg-4">
            <p class="london-office__list-title">{{ blok.column_1_title }}</p>
            <p class="london-office__list-person">{{ blok.column_1_person }}</p>
            <a :href="blok.email_url" class="london-office__link">{{
              blok.email_display
            }}</a>
          </li>
          <li class="london-office__list-item col-12 col-lg-3">
            <p class="london-office__list-title">{{ blok.column_2_title }}</p>
            <p class="london-office__list-person">{{ blok.column_2_person }}</p>
            <a
              :href="blok.phone_url"
              class="london-office__link london-office__link--phone"
              >{{ blok.phone_display }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="london-office--white">
      <div class="container">
        <p>{{ blok.other_offices }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.london-office {
  padding: 0;
  width: 100%;

  &--black {
    background: $black;
    color: $white;
    padding: spacer(3) 0;
  }

  &--white {
    background: $tribal-white;
    color: $black;
    padding: spacer(1) 0;

    p {
      @include font-size(16, rem-v(24));
      @include font-family($font-family-headings-bold, $headings-font-weight);
    }
  }

  &__title {
    @include font-size(36, rem-v(46));
    @include font-family($font-family-headings-bold, $headings-font-weight);

    margin: 0;
    padding: 0;
  }

  &__country {
    @include font-size(16, rem-v(24));
    @include font-family($font-family-headings-bold, $headings-font-weight);

    color: $yellow;
    padding: 0 0 spacer(1);
  }

  &__list {
    display: flex;
    flex-direction: row;
    list-style: none;
    padding: 0;
    margin: 0;

    &-title {
      @include font-size(16, rem-v(24));
      @include font-family($font-family-headings-bold, $headings-font-weight);

      padding: 0;
      margin: spacer(0.3) 0;
    }

    &-intro,
    &-person {
      padding: 0;
      margin: spacer(0.3) 0;
    }

    &-item {
      padding: 0;
      margin: 0;
    }

    &-item:first-child {
      padding-right: spacer(1);
    }

    &-item:not(:first-child) {
      margin: spacer(1) 0;
    }
  }

  &__link {
    color: $white;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      color: $yellow;
      text-decoration: underline;

      &.london-office__link--phone {
        text-decoration: none;
      }
    }

    &.london-office__link--map {
      display: inline-block;
      text-decoration: none;
      margin-top: spacer(0.7);

      span {
        text-decoration: none;
        padding-left: spacer(0.5);

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}

@include media-breakpoint-up(lg) {
  .london-office {
    &__list-item:not(:first-child) {
      margin: 0;
    }
  }
}
</style>
